import React, { useState } from 'react';

import { Button, Input } from '@copilot/ui';
import { Field } from '../common/Field';
import * as documentService from '../../services/documentService';
import { reportError } from '../../services/errorTracking';

const MAX_TITLE_LENGTH = 255;

function ManualDocumentForm({ onCreated }) {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleSave = async () => {
    setError('');
    setSuccessMessage('');

    const trimmedTitle = title.trim();
    const trimmedContent = content.trim();

    if (!trimmedTitle) {
      setError('Title is required.');
      return;
    }

    if (!trimmedContent) {
      setError('Content is required.');
      return;
    }

    // Guards against a double-click firing two creates while the first
    // request is still in flight - the button is also disabled below,
    // but this makes the guard correct even without that.
    if (isSaving) return;

    setIsSaving(true);

    try {
      const document = await documentService.createManualDocument({
        title: trimmedTitle,
        content: trimmedContent,
      });
      setSuccessMessage(`${document.file_name} created.`);
      setTitle('');
      setContent('');
      onCreated?.(document);
    } catch (err) {
      reportError('manual_document_create', err);
      setError(err.message || 'Unable to create document.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="manual-document-form">
      <Field label="Title" htmlFor="manual-document-title">
        <Input
          id="manual-document-title"
          placeholder="Document title"
          maxLength={MAX_TITLE_LENGTH}
          value={title}
          onChange={(event) => setTitle(event.target.value)}
          disabled={isSaving}
        />
      </Field>

      <Field label="Content" htmlFor="manual-document-content">
        <textarea
          id="manual-document-content"
          className="input manual-document-content"
          placeholder="Paste or type the document content..."
          rows={6}
          value={content}
          onChange={(event) => setContent(event.target.value)}
          disabled={isSaving}
        />
      </Field>

      {/* type="button" - same reasoning as DocumentUpload.jsx's Save/
          Upload button: this form is also embedded inside the
          meeting-creation form (pages/StartMeetingPage.jsx). */}
      <Button
        type="button"
        onClick={handleSave}
        disabled={isSaving || !title.trim() || !content.trim()}
      >
        {isSaving ? 'Saving...' : 'Save Document'}
      </Button>

      {error && <div className="form-alert">{error}</div>}
      {successMessage && (
        <div className="document-upload-success">{successMessage}</div>
      )}
    </div>
  );
}

export default ManualDocumentForm;
